import React, { useEffect } from 'react'
import { Route as RouteComponent, Switch as SwitchComponent, Router } from 'react-router-dom'
import type { RouterProps, SwitchProps, RouteProps } from 'react-router'
import './App.css'
import Index from './pages/index'
import Login from './pages/Login/Login'
import Register from './pages/Register/Register'
import RegisterSuccess from './pages/Register/RegisterSuccess/RegisterSuccess'
import CreatAccount from './pages/CreatAccount/CreatAccount'
import InvitationPage from './pages/InvitationPage'
import InvitationSuccess from './pages/InvitationPage/InvitationSuccess/InvitationSuccess'
import CheckoutSuccess from './pages/Checkout/CheckoutSuccess/CheckoutSuccess'
import CheckoutFailed from './pages/Checkout/CheckoutFailed/CheckoutFailed'
import ForgetPassword from "./pages/ForgetPassword";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { DELETE_USER_INFO } from '@/redux/action'
import { useMappedState, useDispatch } from "redux-react-hook";
import { IState } from '@/redux/interface'
import { createHashHistory } from 'history';
import { useTranslation } from 'react-i18next';
import zh_CN from 'antd/es/locale-provider/zh_CN';
import en_US from 'antd/es/locale-provider/en_US';
import { ConfigProvider } from 'antd';
import { getToken } from './request'
import { userApi } from "@/api";
import { getUserInfo } from './api/user/user'
import { message } from 'antd'
import i18next from "i18next";
import { signOut } from './utils/utils'
import { SAVE_USER_INFO } from './redux/action'
import { getItem, setItem } from '@/utils/secureStorage'

export const history = createHashHistory();

// Type workaround: React 18 @types conflict with react-router-dom v5 Router (refs property)
type RouterWithChildrenProps = RouterProps & { children?: React.ReactNode };
const RouterComponent = Router as unknown as React.ComponentType<RouterWithChildrenProps>;
const Switch = SwitchComponent as unknown as React.ComponentType<SwitchProps>;
const Route = RouteComponent as unknown as React.ComponentType<RouteProps>;

const AppRoute = () => {

  const userInfo = useMappedState((state: IState) => state.UserInfoReducer.userInfo);

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const location = history.location

  useEffect(() => {
    let local = getItem('wapipay-website-locale');
    if (local) {
      i18n.changeLanguage(local)
    } else {
      i18n.changeLanguage('en')
      setTimeout(() => {
        setItem('wapipay-website-locale', 'en');
      }, 0)
    }
  }, [])
  useEffect(() => {
    // Only clear session when there's no token - userInfo may not be in storage (e.g. production doesn't store it)
    const token = getToken()
    if (!token) {
      dispatch({ type: DELETE_USER_INFO })
    }
    // Don't redirect to /home when on checkout or invitation (public web view) paths
    const isPublicPath = /^\/(checkoutSuccess|checkoutFailed|invitation|invitationSuccess)/.test(location.pathname)
    if (location.pathname.length <= 1 && !isPublicPath) {
      history.push('/home')
    }
  }, [])

  useEffect(() => {
    getNewUserInfo()
  }, [])

  const getNewUserInfo = async () => {
    try {
      const token = getToken()
      if (token) {
        const res = await userApi.getUserInfo()
        dispatch({ type: SAVE_USER_INFO, userInfo: res })
        setItem('userInfo', JSON.stringify(res))
      }
    } catch (error: any) {
      // Only sign out on 401 (session/token expired) - not on network errors or 5xx
      const isUnauthorized = error?.response?.status === 401 || error?.code === 401
      if (isUnauthorized) {
        message.warning(i18next.t("User information parsing failed, please log in again!"))
        signOut()
        setTimeout(() => {
          window.location.reload()
        }, 2000);
      }
      // Other errors (network, 500, etc.) - don't sign out, let user retry
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  })
  return (
    <ConfigProvider locale={i18n.language === 'en' ? en_US : zh_CN}>
      <RouterComponent history={history}>
        <Switch>
          {/* Checkout and invitation (public web view) routes first so they never match the catch-all path='/' */}
          <Route exact path='/checkoutSuccess' render={() => <CheckoutSuccess />}></Route>
          <Route exact path='/checkoutFailed' render={() => <CheckoutFailed />}></Route>
          <Route exact path='/invitation' render={() => <InvitationPage />}></Route>
          <Route exact path='/invitationSuccess' render={() => <InvitationSuccess />}></Route>
          <Route exact path='/login' render={() => <Login />}></Route>
          <Route exact path='/register' render={() => <Register />}></Route>
          <Route exact path='/creatAccount' render={() => <CreatAccount />}></Route>
          <Route exact path='/registerSuccess' render={() => <RegisterSuccess />}></Route>
          <Route exact path='/forgetPassword' render={() => <ForgetPassword />}></Route>
          <Route exact path='/terms' render={() => <Terms />}></Route>
          <Route exact path='/privacyPolicy' render={() => <PrivacyPolicy />}></Route>
          {/* Catch-all: for checkout only, never render Index (fixes staging when path='/' matches first) */}
          <Route
            path='/'
            render={({ location }) => {
              const p = location.pathname
              if (p === '/checkoutSuccess') return <CheckoutSuccess />
              if (p === '/checkoutFailed') return <CheckoutFailed />
              return <Index />
            }}
          ></Route>
        </Switch>
      </RouterComponent>
    </ConfigProvider>
  )
}

export default AppRoute